import jwtDecode from "jwt-decode";
import http, { setJwt } from "../http";
import { _URL } from "../../config.json";
const apiEndpoint = `${_URL}/api/Auth`;
const LangJwt = "lang";
const companyIdJwt = "comId";
const tokenKey = "token";
const refreshTokenKey = "refreshToken";

export const permissions = {};

export function getRolesJwt() {
  try {
    const jwt = getJwt(tokenKey);
    const { rol } = jwtDecode(jwt);
    const ArrayData = rol.split(",");

    for (var i = 0; i < ArrayData.length; i++) {
      const supp = ArrayData[i];
      permissions[supp] = true;
    }
  } catch (ex) {
    return null;
  }
}

setJwt(getJwt());

export async function login(userName, password) {
  const { data } = await http.post(`${apiEndpoint}/login`, {
    userName,
    password,
  });
  
  saveJwt(data.token);
  saveRefreshJwt(data.refreshToken);
  saveLangJwt();
  saveCompanyId();
}

export function logout() {
  localStorage.removeItem(tokenKey);
  localStorage.removeItem(refreshTokenKey);
  localStorage.removeItem(companyIdJwt);
  sessionStorage.clear();
}

export function getCurrentUser() {
  try {
    const jwt = getJwt(tokenKey);
    const user = jwtDecode(jwt);
    //if (user.exp < Date.now() / 1000) return null
    return user;
  } catch (ex) {
    return null;
  }
}

export async function refreshJwt() {
  const tokenObj = {
    token: getJwt(),
    refreshToken: getRefreshJwt(),
  };
  console.log(getJwt());
  console.log(tokenObj);
  try {
    const refreshResponse = await http.post(
      `${apiEndpoint}/refreshtoken`,
      tokenObj
    );
    console.log("refreshResponse:", refreshResponse);
    setJwt(refreshResponse.data.token);
    saveJwt(refreshResponse.data.token);
    saveRefreshJwt(refreshResponse.data.refreshToken);
    return refreshResponse;
  } catch (err) {
    console.log("error:", err.response);
    return err;
  }
}

export async function refreshToken() {
  const tokenObj = {
    token: getJwt(),
    refreshToken: getRefreshJwt(),
  };
  try {
    const result = await http.post(`${apiEndpoint}/refreshtoken`, tokenObj);

    saveJwt(result.data.token);
    saveRefreshJwt(result.data.refreshToken);
    setJwt(getJwt());
    return result;
  } catch (err) {
    console.log("error:", err.response);
    return err;
  }
}

export function saveCompanyId() {
  try {
    const jwt = getJwt(tokenKey);
    const { companyId } = jwtDecode(jwt);
    return localStorage.setItem(companyIdJwt, companyId);
  } catch (ex) {
    return null;
  }
}

export function saveLangJwt() {
  try {
    const jwt = getJwt(tokenKey);
    const { lang } = jwtDecode(jwt);
    return localStorage.setItem(LangJwt, lang);
  } catch (ex) {
    return null;
  }
}

export function saveJwt(token) {
  return localStorage.setItem(tokenKey, token);
}

export function saveRefreshJwt(refreshToken) {
  return localStorage.setItem(refreshTokenKey, refreshToken);
}

export function getJwt() {
  return localStorage.getItem(tokenKey);
}

export function getRefreshJwt() {
  return localStorage.getItem(refreshTokenKey);
}

export default {
  login,
  logout,
  getCurrentUser,
  getRolesJwt,
  getJwt,
};
